import CompanyLogo from "assets/images/companyLogo.svg";
import companyBlueLogo from "assets/images/blueLogo.svg"
import Favicon from "assets/images/favicon.ico";


export const companyDetails = {
    companyName: "ITER-Frontdesk",
    favicon: Favicon,
    companyLogo: CompanyLogo,
    companyBlueLogo:companyBlueLogo,
}